import { render } from "./TestResultListView.vue?vue&type=template&id=454331e9&scoped=true"
import script from "./TestResultListView.vue?vue&type=script&lang=js"
export * from "./TestResultListView.vue?vue&type=script&lang=js"

import "./TestResultListView.vue?vue&type=style&index=0&id=454331e9&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454331e9"]])

export default __exports__